import PropTypes from 'prop-types';
import React, { useContext, useMemo } from 'react';
import { emptyObject } from 'ui-components/default-props/empty';
import { noop } from 'ui-components/default-props/noop';
import { ChildrenPropType } from '../../prop-types/children';

const CreditCardContext = React.createContext({});
export const useCreditCardContext = () => useContext(CreditCardContext);

export const CreditCardContextProvider = ({
  children,
  creditCardInfo,
  onChange = noop,
  onBlur = noop,
  errors = emptyObject,
  disabled = false,
  showAllErrors = false,
}) => {
  const value = useMemo(
    () => ({
      creditCardInfo,
      onChange,
      onBlur,
      errors,
      disabled,
      showAllErrors,
    }),
    [creditCardInfo, onChange, onBlur, errors, disabled, showAllErrors],
  );

  return <CreditCardContext.Provider value={value}>{children}</CreditCardContext.Provider>;
};

CreditCardContextProvider.propTypes = {
  children: ChildrenPropType.isRequired,
  creditCardInfo: PropTypes.shape({
    cardName: PropTypes.string,
    cardProvider: PropTypes.string,
    cardNumber: PropTypes.string,
    expiry: PropTypes.string,
    cvv: PropTypes.string,
  }).isRequired,
  onChange: PropTypes.func,
  errors: PropTypes.shape({
    cardName: PropTypes.object,
    cardProvider: PropTypes.object,
    cardNumber: PropTypes.object,
    expiry: PropTypes.object,
    cvv: PropTypes.object,
  }),
  onBlur: PropTypes.func,
  disabled: PropTypes.bool,
  showAllErrors: PropTypes.bool,
};
